import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {CategoryModel} from '../../models/category.model';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-category',
  templateUrl: 'category.component.html',
  styleUrls: ['category.component.scss']
})

export class CategoryComponent implements  OnInit {
  @Input() model: CategoryModel;
  @Input() cascadeSelected:Subject<string>;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  isSelected = 'false';
  selectedCss = 'category category-selected';
  unselectedCss = 'category category-unselected';
  hoverCss = 'category-unselected-hover';
  class = '';

  ngOnInit(): void {
    this.class = this.getClass();
    this.cascadeSelected.subscribe(id => {
      this.class = this.getClass();
      this.isSelected = this.getSelected();
    });
  }

  getSelected(): string {
    return this.model.selected ? 'true' : 'false';
  }

  getClass(): string {
    return this.model.selected ? this.selectedCss : this.unselectedCss;
  }

  clicked($event) {
    this.selected.emit(this.model.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/components/category/category.component.ts